export const getErrorCode = (error) => {
  const parsedError = error?.response?.data?.error ? JSON.parse(error.response.data.error) : null;
  if (parsedError?.code) {
    return parsedError.code;
  } else if (error?.error?.data?.code) {
    return error.error.data.code;
  } else if (error?.code) {
    return error.code;
  } else {
    return null;
  }
};
